import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7e152055")

_pushScopeId("data-v-7e152055")
const _hoisted_1 = {
  class: "btn btn-outline btn-outline-dashed btn-outline-default p-7 d-flex align-items-center",
  style: {"min-height":"122px"}
}
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3x me-5" }, [
  /*#__PURE__*/_createVNode("i", { class: "bi bi-life-preserver icon-size" })
], -1)
const _hoisted_3 = { class: "d-block fw-bold text-start" }
const _hoisted_4 = { class: "settings-heading fw-bolder d-block fs-4 mb-2" }
const _hoisted_5 = { class: "fw-bold fs-6 ecnomic-settings-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode(_component_router_link, {
      to: "#",
      onClick: _ctx.getProducts
    }, {
      default: _withId(() => [
        _createVNode("label", _hoisted_1, [
          _hoisted_2,
          _createVNode("span", _hoisted_3, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('message.PRODUCTS')), 1),
            _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('message.SYNC_ALL_PRODUCTS_FROM_ECONOMIC')), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["onClick"])
  ], 64))
})